import { useFormik } from 'formik';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import '../scss/button.scss';
import * as Yup from 'yup';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { ReactComponent as CheckIconGreen } from '../images/check-icon.svg'
import { ReactComponent as UploadIcon } from '../images/upload-icon.svg'
import { ReactComponent as UploadCloudIcon } from '../images/upload-cloud-icon.svg'
import { ReactComponent as CheckIconChk } from '../images/check-icon-green.svg'
import SelectDropdown from '../components/SelectDropdown';
import { useCheckMissingDetailsMutation, useSubmitMissingDetailsMutation } from '../lib/services/personalDetailsApi';
import { useDispatch, useSelector } from 'react-redux';
import { closeUploadModal, openUploadModal, setFileError, setMissingDetails, setPageError, setSelectedDocType, setFileData, setUploadedFile } from '../lib/features/personalDetailsSlice';
import CenteredPopup from '../components/popups/CenteredPopup';
import { useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import BottomPopup from '../components/popups/BottomPopup';
import { useUpdateFileMutation } from '../lib/services/fileApi';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
//import { useSkipPageMutation } from '../lib/services/businessApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function PersonalDetails() {
    const dispatch = useDispatch()
    const fileInputRef = useRef(null)
    const navigate = useNavigate()
    const location = useLocation()
    const footerRef = useRef(null);
    const [submitMissingDetails, { isLoading }] = useSubmitMissingDetailsMutation()
    const [tapClick] = useTapClickMutation()
    const [updateFile, { isLoading: isUpdating }] = useUpdateFileMutation()
    //const [skipPage, { isLoading: skippingPage }] = useSkipPageMutation()
    const [checkMissingDetails] = useCheckMissingDetailsMutation();
    const { missingDetails, pageerror, selectedDocType, isUploadModalOpen, fileerror, fileData, uploadedImage } = useSelector((state) => state.personalDetails);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [isDragging, setIsDragging] = useState(false)
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const docuTypeListRented = ['Rent agreement', 'Gas bill', 'Mobile bill with address']
    const docuTypeListOwned = ['Electricity bill', 'House Tax Receipt', 'Sale Deed']
    const [bottomPosition, setBottomPosition] = useState(10);
    const [custSeg, setCustSeg] = useState('');
    //const custSeg = localStorage.getItem('customerSegment')
    useEffect(() => {
        localStorage.setItem('customerSegment', custSeg.toLowerCase())
    }, [custSeg])
    const handleOpen = () => {
        setIsModalOpen(true);
    }
    const handleClose = () => {
        setIsModalOpen(false);
        dispatch(setPageError(''))
    }

    const handleUploadButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Handle file selection
    const handleFileChange = (event) => {
        const files = event.target.files;
        handleFiles(files);
    };

    // Handle drag and drop files
    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);

        const files = event.dataTransfer.files;
        handleFiles(files);
    };

    // Handle drag over event
    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(true);
    }

    // Handle drag leave event
    const handleDragLeave = () => {
        setIsDragging(false);
    };

    // Process files
    const handleFiles = (files) => {
        dispatch(setFileError(''))
        const supportedFormats = ['.jpg', '.jpeg', '.png', '.pdf', '.svg'];
        const maxFileSizeMB = 3

        if (files.length > 0) {
            const file = files[0];
            const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;
            const fileSizeMB = file.size / (1024 * 1024)

            if (fileSizeMB > maxFileSizeMB) {
                dispatch(setFileError('File size exceeds the 3MB limit.'));
                return;
            }

            if (!supportedFormats.includes(fileExtension)) {
                dispatch(setFileError('Unsupported file format.'));
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result;
                dispatch(setFileData(base64Data));
            };
            reader.onerror = () => {
                dispatch(setFileError('An error occurred while reading the file. Please try again.'));
            };

            reader.readAsDataURL(file); // Read file as a Data URL to convert to Base64
        } else {
            dispatch(setFileError('No files selected.'));
        }
    }
    const modalButtons = [
        { label: 'Close', onClick: handleClose }
    ]
    useEffect(() => {
        const getMissingDetails = async () => {
            try {
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const result = await checkMissingDetails({ jwt_token, scrt })
                if (result.data && result.data.status === 'error') {
                    dispatch(setPageError(result.data.message))
                    handleOpen()
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    }
                } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
                    handleOpen()
                    dispatch(setPageError(result.data.message))
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                } else if (result.error) {
                    dispatch(setPageError('Please check your internet or try again later.'))
                    handleOpen()
                } else {
                    dispatch(setMissingDetails({ ...result.data }))
                    if (result.data.customer_segmentation) {
                        localStorage.setItem('customerSegment', result.data.customer_segmentation.toLowerCase())
                        setCustSeg(result.data.customer_segmentation.toLowerCase())
                    }
                }
            } catch (error) {
                dispatch(setPageError('Something went wrong. Please try again later.'));
                handleOpen()
            }
        }
        getMissingDetails()
    }, [checkMissingDetails, dispatch, navigate, jwt, secret])

    const submitBasicDetails = async (values) => {
        const data = {
            fathers_name: values.fatherName,
            occupation: values.occupation === 'Self employed' ? 'self employed' : values.occupation,
            house_flat_no: values.houseFlatNo || '',
            address_line_1: values.addressLine1.trim() || '',
            address_line_2: values.addressLine2.trim() || '',
            pin_code: values.pinCode.split(' ').join('') || '',
            //permanent_address_check: values.isAddressSame ? 1 : 0,
            current_house_type: values.addressType ? values.addressType : '',
            /*permanent_house_flat_no: values.permHouseFlatNo || '',
            permanent_address_line_1: values.permAddressLine1 || '',
            permanent_address_line_2: values.permAddressLine2 || '',
            permanent_pin_code: values.permPinCode || '',*/
        }
        let jwt_token
        if (jwt) {
            jwt_token = jwt
            localStorage.setItem('jwt', jwt)
        } else {
            jwt_token = localStorage.getItem('jwt')
        }
        const scrt = secret ? secret : localStorage.getItem('secret')
        const result = await submitMissingDetails({ ...data, jwt_token, scrt })
        if (result && result.data && result.data.status === 'error' && result.data.message === 'Login expired! Please re-login.') {
            localStorage.removeItem('jwt');
            localStorage.removeItem('lastVisitedPage');
            const phone = localStorage.getItem('phone')
            localStorage.clear()
            phone ? navigate(`/?phone=${phone}`) : navigate('/');
        }
        else if (result.data && result.data.http_code === 201) {
            dispatch(setPageError(result.data.message))
            handleOpen()
        } else if (result && result.data && result.data.status === 'error') {
            dispatch(setPageError(result.data.message))
            handleOpen()
        } else if (result.error) {
            dispatch(setPageError('Please check your internet or try again later.'))
            handleOpen()
        } else if (result && result.data && result.data.status === 'success') {
            //localStorage.setItem("lastVisitedPage", '/final-approval')
            //navigate('/final-approval');
            const event_name = 'web_address_detail_submit'
            const event_property = { 
                Source: localStorage.getItem('utm_source'), 
                segment: result.data.customer_segmentation, 
                occupation: data.occupation, 
                'pin code': data.pin_code,  
                "current address type": values.addressType || data.current_house_type
            }
            debugger
            await pushCleverTapEvent({ event_name, event_property })
            if (result.data.redirect_url) {
                window.location.href = result.data.redirect_url
            }
        }
    }
    const validationSchema = Yup.object({
        fatherName: Yup.string().required("Father's Name is required").test(
            "fatherName-alphabetic",
            "Father's Name must contain only alphabetic characters",
            (value) => /^[A-Za-z\s]+$/.test(value)
        ),
        occupation: Yup.string().required("Occupation Type is required"),
        houseFlatNo: Yup.string().required("House/Flat no is required"),
        addressLine1: Yup.string().required("Address Line-1 is required"),
        addressLine2: Yup.string(),
        pinCode: Yup.string()
            .nullable()
            .test(
                "is-not-blank",
                "PIN Code cannot be blank",
                (value) => value === "N/A" || !!value
            )
            .test(
                "is-six-digits",
                "PIN Code must be exactly 6 digits long",
                (value) => !value || /^\d{3} \d{3}$/.test(value)
            )
            .test(
                "only-digits",
                "PIN Code must only contain numeric digits",
                (value) => !value || /^\d{3}( \d{3})*$/.test(value)
            )
            .test(
                "no-leading-zero",
                "PIN Code must not start with zero",
                (value) => !value || /^[1-9]/.test(value)
            ),
        addressType: Yup.string().required("Address detail is required"),
        /*permHouseFlatNo: Yup.string(),
        permAddressLine1: Yup.string()
            .test('address-check', 'Address Line-1 is required', function (value) {
                return this.parent.isAddressSame || (value && value.trim().length > 0);
            }),
        permAddressLine2: Yup.string()
            .test('address-check', 'Address Line-2 is required', function (value) {
                return this.parent.isAddressSame || (value && value.trim().length > 0);
            }),
        permPinCode: Yup.string()*/
        /*.test('pin-check', 'PIN Code is required', function (value) {
            return this.parent.isAddressSame || (value && value.trim().length === 6);
        })*/
        /*.test(
            "only-digits",
            "PIN Code must only contain numeric digits",
            function (value) {
                return this.parent.isAddressSame || (value && /^\d+$/.test(value))
                //!value || /^\d+$/.test(value)
            }
        )
        .test(
            "no-leading-zero",
            "PIN Code must not start with zero",
            function (value) {
                //!value || /^[1-9]/.test(value)
                return this.parent.isAddressSame || (value && /^[1-9]/.test(value))
            }
        )
        .test(
            "is-six-digits",
            "PIN Code must be exactly 6 digits long",
            function (value) {
                return this.parent.isAddressSame || (value && /^\d{6}$/.test(value))
                //!value || /^\d{6}$/.test(value)
            }
        )
        .matches(/^\d{6}$/, "PIN Code must be 6 digits"),*/
    });
    const formik = useFormik({
        initialValues: {
            pinCode: '',
            houseFlatNo: '',
            addressLine1: '',
            addressLine2: '',
            fatherName: '',
            occupation: '',
            addressType: null,
            /*permHouseFlatNo: '',
            permAddressLine1: '',
            permAddressLine2: '',
            permPinCode: '',*/
        },
        validationSchema,
        onSubmit: async (values) => {
            submitBasicDetails(values)
        },
    });

    const handleConfirm = async () => {
        const data = {
            document_name: selectedDocType ? selectedDocType.toLowerCase() : '',
            document_string: fileData,
        }
        let jwt_token
        if (jwt) {
            jwt_token = jwt
            localStorage.setItem('jwt', jwt)
        } else {
            jwt_token = localStorage.getItem('jwt')
        }
        const scrt = secret ? secret : localStorage.getItem('secret')
        const result = await updateFile({ ...data, jwt_token, scrt })
        if (result && result.data && result.data.status === 'error' && result.data.message === 'Login expired! Please re-login.') {
            localStorage.removeItem('jwt');
            localStorage.removeItem('lastVisitedPage');
            const phone = localStorage.getItem('phone')
            localStorage.clear()
            phone ? navigate(`/?phone=${phone}`) : navigate('/');
        }
        else if (result.data && result.data.http_code === 201) {
            dispatch(setPageError(result.data.message))
            handleOpen()
        } else if (result && result.data && result.data.status === 'error') {
            if (result.data.message.includes('files are not suported')) {
                dispatch(setPageError('Files are not suported.Please upload jpg, png, tiff or pdf'))
            } else {
                dispatch(setPageError(result.data.message))
            }
            handleOpen()
        } else if (result.error) {
            dispatch(setPageError('Please check your internet or try again later.'))
            handleOpen()
        } else if (result && result.data && result.data.status === 'success') {
            debugger;
            dispatch(setPageError(''))
            dispatch(setFileError(''))
            dispatch(setUploadedFile(result.data.thumb_url))
            const event_name = 'Web__document_submited'
            const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation || localStorage.getItem('customerSegment'), occupation: formik.values.occupation || '', doctype: selectedDocType || '' }
            await pushCleverTapEvent({ event_name, event_property })
            dispatch(closeUploadModal())
            //localStorage.setItem("lastVisitedPage", '/final-approval')
            //navigate('/final-approval');
            //if (result.data.redirect_url) {
            //window.location.href = result.data.redirect_url
            //}
        }
    }
    const { setFieldValue } = formik;

    useEffect(() => {
        if (missingDetails) {
            if (missingDetails.fathers_name) setFieldValue('fatherName', missingDetails.fathers_name)
            if (missingDetails.emp_type) setFieldValue('occupation', missingDetails.emp_type)
            if (missingDetails.pin_code) setFieldValue('pinCode', missingDetails.pin_code)
            if (missingDetails.house_flat_no) setFieldValue('houseFlatNo', missingDetails.house_flat_no)
            if (missingDetails.address_line_1) setFieldValue('addressLine1', missingDetails.address_line_1)
            if (missingDetails.address_line_2) setFieldValue('addressLine2', missingDetails.address_line_2)
            //if (missingDetails.permanent_address_check) setFieldValue('isAddressSame', missingDetails.permanent_address_check)
            if (missingDetails.current_house_type) setFieldValue('addressType', missingDetails.current_house_type === 'rented' ? true : false)
            /*if (missingDetails.permanent_house_flat_no) setFieldValue('permHouseFlatNo', missingDetails.permanent_house_flat_no)
            if (missingDetails.permanent_address_line_1) setFieldValue('permAddressLine1', missingDetails.permanent_address_line_1)
            if (missingDetails.permanent_address_line_2) setFieldValue('permAddressLine2', missingDetails.permanent_address_line_2)
            if (missingDetails.permanent_pin_code) setFieldValue('permPinCode', missingDetails.permanent_pin_code)*/
        }
    }, [missingDetails, setFieldValue])
    useEffect(() => {
        //const viewport = window.visualViewport;
        const updateFooterPosition = () => {
            let height = window.visualViewport.height;
            if (!/iPhone|iPad|iPod|Android/.test(window.navigator.userAgent)) {
                height = window.visualViewport.height;
            }
            setBottomPosition(height - window.visualViewport.height + 10);
        }
        updateFooterPosition();
        window.visualViewport.addEventListener("resize", updateFooterPosition);
        window.visualViewport.addEventListener("scroll", updateFooterPosition);

        return () => {
            window.visualViewport.removeEventListener("resize", updateFooterPosition);
            window.visualViewport.removeEventListener("scroll", updateFooterPosition);
        };
    }, [])

    /*const handleSkip = async () => {
        try {
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const result = await skipPage({ jwt_token, scrt })
            if ((result.data && (result.data.status === 'error' || result.data.status === false)) || (result && result.status === 'error')) {
                dispatch(setPageError(result.data.message || 'Some error occured. Please try again.'))
                handleOpen()
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                }
            } else if (result.data && result.data.http_code === 201) {
                if (result.data.message === 'Login expired! Please re-login.') {
                    dispatch(setPageError(result.data.message))
                    handleOpen()
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                } else {
                    dispatch(setPageError(result.data.message))
                    handleOpen()
                }
            } else if (result.error) {
                dispatch(setPageError('Please check your internet or try again later.'))
                handleOpen()
            } else {
                if (result && result.data && result.data.redirect_url) {
                    window.location.href = result.data.redirect_url
                }
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
        }
    }*/

    return (
        <div className={`external-wrapper personal-details ${isKeyboardOpen ? 'keyboard-active' : ''}`}>
            <CenteredPopup
                isOpen={isModalOpen}
                buttons={modalButtons}
                onClose={handleClose} icon={pageerror && pageerror === "File Upload Successfully" ? <CheckIconGreen /> : <WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className='page-content'>
                <PageHeader />
                <div className='page-heading'>
                    <h2 className='page-title'>Just a few more details to proceed</h2>
                </div>
                <form onSubmit={formik.handleSubmit} className='personal-details'
                    onBlur={(e) => {
                        formik.handleBlur(e);
                        setTimeout(() => {
                            if (!document.activeElement || document.activeElement.tagName !== "INPUT") {
                                setIsKeyboardOpen(false);
                            }
                        }, 100);
                    }}
                    onFocus={() => setIsKeyboardOpen(true)}>
                    <div className="input-wrapper">
                        <input
                            type="text"
                            autoComplete='off'
                            name="fatherName"
                            placeholder=" "
                            value={formik.values.fatherName}
                            onChange={(e) => {
                                const value = e.target.value;
                                const formattedValue = value.replace(/[^A-Za-z\s]/g, "");
                                formik.setFieldValue("fatherName", formattedValue);
                            }}
                            onBlur={formik.handleBlur}
                            className={`form-control`}
                        />
                        <label>Your Father's Name*</label>
                        {formik.errors.fatherName && formik.touched.fatherName && (
                            <div className="error">{formik.errors.fatherName}</div>
                        )}
                    </div>

                    {!missingDetails || (missingDetails && !missingDetails.emp_type) ? <div className="input-wrapper">
                        <SelectDropdown
                            name="occupation" id="occupationControl"
                            options={['Salaried', 'Self employed']}
                            labelText='Your Occupation Type*'
                            value={formik.values.occupation ? formik.values.occupation : ''}
                            onChange={(option) => {
                                formik.setFieldValue('occupation', option)
                            }}
                        />
                        {formik.errors.occupation && formik.touched.occupation && (
                            <div className="error">{formik.errors.occupation}</div>
                        )}
                    </div> : null}



                    <div className="input-wrapper radio-wrapper">
                        <label className='radio-label'>Please enter your current address details</label>
                        <div className='radios'>
                            <div className='radio'>
                                <input
                                    type="radio"
                                    id='rented'
                                    name="addressType"
                                    value="rented"
                                    checked={formik.values.addressType === 'rented'}
                                    onChange={() => {
                                        formik.setFieldValue('addressType', 'rented')
                                        dispatch(setSelectedDocType(null))
                                    }}
                                />{' '}
                                <label htmlFor="rented" className='noabs'>Rented</label>
                            </div>
                            <div className='radio'>
                                <input
                                    type="radio"
                                    name="addressType"
                                    id='owned'
                                    value="self owned"
                                    checked={formik.values.addressType === 'self owned'}
                                    onChange={() => {
                                        formik.setFieldValue('addressType', 'self owned')
                                        dispatch(setSelectedDocType(null))
                                    }}
                                    className="ms-3"
                                />{' '}
                                <label htmlFor='owned' className='noabs'>Self-Owned</label>
                            </div>
                        </div>
                        {formik.errors.addressType && formik.touched.addressType && (
                            <div className="error">{formik.errors.addressType}</div>
                        )}
                    </div>
                    <div className="input-wrapper">
                        <input
                            type="text"
                            autoComplete='off'
                            name="houseFlatNo"
                            placeholder=" "
                            value={formik.values.houseFlatNo}
                            onChange={(e) => {
                                const value = e.target.value;
                                formik.setFieldValue("houseFlatNo", value);
                            }}
                            onBlur={formik.handleBlur}
                            className="form-control"
                        />
                        <label>House/flat no*</label>
                        {formik.errors.houseFlatNo && formik.touched.houseFlatNo && (
                            <div className="error">{formik.errors.houseFlatNo}</div>
                        )}
                    </div>

                    <div className="input-wrapper">
                        <input
                            type="text"
                            autoComplete='off'
                            name="addressLine1"
                            placeholder=" "
                            value={formik.values.addressLine1}
                            onChange={(e) => {
                                const value = e.target.value;
                                formik.setFieldValue("addressLine1", value);
                            }}
                            onBlur={formik.handleBlur}
                            className={`form-control`}
                        />
                        <label>Address line-1*</label>
                        {formik.errors.addressLine1 && formik.touched.addressLine1 && (
                            <div className="error">{formik.errors.addressLine1}</div>
                        )}
                    </div>

                    <div className="input-wrapper">
                        <input
                            type="text"
                            autoComplete='off'
                            name="addressLine2"
                            placeholder=" "
                            value={formik.values.addressLine2}
                            onChange={(e) => {
                                const value = e.target.value;
                                formik.setFieldValue("addressLine2", value);
                            }}
                            onBlur={formik.handleBlur}
                            className="form-control"
                        />
                        <label>Address Line-2</label>
                        {formik.errors.addressLine2 && formik.touched.addressLine2 && (
                            <div className="error">{formik.errors.addressLine2}</div>
                        )}
                    </div>

                    <div className="input-wrapper">
                        <input
                            type="text"
                            autoComplete='off'
                            name="pinCode"
                            placeholder=" "
                            inputMode="numeric"
                            value={formik.values.pinCode}
                            minLength={7}
                            maxLength={7}
                            onChange={(e) => {
                                const value = e.target.value ? e.target.value.replace(/[^0-9]/g, "") : '';
                                const formattedValue = value ? value
                                    .match(/.{1,3}/g)
                                    ?.join(" ")
                                    .slice(0, 7) : '';
                                formik.setFieldValue("pinCode", formattedValue);
                            }}
                            onBlur={formik.handleBlur}
                            className={`form-control`}
                        />
                        <label>PIN Code*</label>
                        {formik.errors.pinCode && formik.touched.pinCode && (
                            <div className="error">{formik.errors.pinCode}</div>
                        )}
                    </div>
                    {/*!custSeg || (custSeg && custSeg.toLowerCase() !== 'a1-a2') ? <>
                        <div className="input-wrapper">
                            <SelectDropdown
                                name="docuType" id="docuType"
                                options={formik.values.addressType === 'rented' ? docuTypeListRented : docuTypeListOwned}
                                labelText='Select document Type'
                                value={selectedDocType ? selectedDocType : ''}
                                onChange={(option) => {
                                    dispatch(setSelectedDocType(option))
                                }}
                            />
                        </div>
                        <div className={uploadedImage ? 'upload-button uploaded' : 'upload-button'} onClick={() => dispatch(openUploadModal())}>
                            <div className='text'>{uploadedImage ? 'Document uploaded' : 'Upload document*'}</div>
                            <div className='icon'>{uploadedImage ? <><div className='image'><img src={uploadedImage} alt='Uploaded' /></div><CheckIconChk /></> : <UploadIcon className='branding-icon' />}</div>
                        </div>
                        {uploadedImage ? <div className='reupload' onClick={() => dispatch(openUploadModal())}>Re-upload</div> : null}
                    </> : null*/}

                    {/* Permanent Address fields */}
                    {/*!formik.values.isAddressSame && (
                        <>
                            <div className='page-heading'>
                                <h2 className='page-title'>Please enter your permanent address</h2>
                            </div>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    name="permHouseFlatNo"
                                    placeholder=" "
                                    value={formik.values.permHouseFlatNo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="form-control"
                                />
                                <label>House/flat no (Optional)</label>
                            </div>

                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    name="permAddressLine1"
                                    placeholder=" "
                                    value={formik.values.permAddressLine1}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={`form-control`}
                                />
                                <label>Address Line-1</label>
                                {formik.errors.permAddressLine1 && formik.touched.permAddressLine1 && (
                                    <div className="error">{formik.errors.permAddressLine1}</div>
                                )}
                            </div>

                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    name="permAddressLine2"
                                    placeholder=" "
                                    value={formik.values.permAddressLine2}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="form-control"
                                />
                                <label>Address Line-2</label>
                                {formik.errors.permAddressLine2 && formik.touched.permAddressLine2 && (
                                    <div className="error">{formik.errors.permAddressLine2}</div>
                                )}
                            </div>

                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    name="permPinCode"
                                    placeholder=" "
                                    minLength={6}
                                    maxLength={6}
                                    value={formik.values.permPinCode}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={`form-control`}
                                />
                                <label>PIN Code</label>
                                {formik.errors.permPinCode && formik.touched.permPinCode && (
                                    <div className="error">{formik.errors.permPinCode}</div>
                                )}
                            </div>
                        </>
                    )*/}
                    {/*<div className={`skip-link link ${skippingPage ? 'disabled' : ''}`} onClick={handleSkip}>Skip</div>*/}
                    <div className='bottom-footer p-0' ref={footerRef} style={{ bottom: `${bottomPosition}px` }}>
                        <p className='powered-by'>Powered by <StarfinLogo /></p>
                        <button type="submit" className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}>Continue</button>
                    </div>
                </form>

                <BottomPopup
                    isOpen={isUploadModalOpen}
                    onClose={() => dispatch(closeUploadModal())}
                    title="Upload files"
                    //content={bankDetails}
                    className="upload-modal"
                    buttons={[{
                        label: 'Upload & Save',
                        onClick: handleConfirm,
                        disabled: !fileData || isUpdating
                    }]}>
                    <div className={`upload-box ${isDragging ? 'dragging' : ''}`}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onDragLeave={handleDragLeave}>
                        <UploadCloudIcon className='cloud-icon branding-icon' />
                        <p>Max Size: 3 MB | Supported Formats: .jpg, .jpeg, .png, .pdf, .svg</p>
                        <button type="button" className='btn btn-primary-outlined' onClick={handleUploadButtonClick}>Browse files</button>
                        {fileerror && <div className='error'>{fileerror}</div>}
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                    </div>
                </BottomPopup>
            </div>
        </div>
    )
}

export default PersonalDetails
